import { useParams } from "react-router-dom";
import { useState } from "react";
import { updateProgressReduxCB } from "../util/helpersFunction.js";
import locationTask from "../data/locationTask.json";
import images from "../images/images.js";
import { FactFictionView } from "../views/factFictionView.jsx";

function FactFiction() {
  const { mode, id } = useParams();
  const location = locationTask[id];
  const factsData = location?.[`${mode}Facts`];
  const title = location?.title;
  const imageKey = `drawing_${id}`;
  const answerLabels = ["A", "B", "C", "D"];
  const quest = "factFiction";

  const [answered, setAnswered] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [currentStep, setCurrentStep] = useState(3)
  console.log(factsData);
  

  if (!factsData) return <div>No facts available for this mode.</div>;

  function handleAnswerClickACB(choice) {
    const { correctAnswer, correctComment, incorrectComment } = factsData;
    const isRight = choice === correctAnswer;

    console.log(isRight);

    setAnswered(true);
    setFeedback(isRight ? (correctComment || "Correct!") : (incorrectComment || "Incorrect!"));
    setCurrentStep(4); // advance progress bar

    const status = isRight ? "success" : "fail";
    updateProgressReduxCB(id, mode, status, quest);
  }

  function handleGoToModeInfoACB() {
    window.location.hash = `#/questComplete/${id}/${mode}/${quest}`;
  }

  return (
    <FactFictionView
      mode={mode}
      factsData={factsData}
      onAnswer={handleAnswerClickACB}
      onComplete={handleGoToModeInfoACB}
      answered={answered}
      feedback={feedback}
      currentStep={currentStep}
      title={title}
      imageKey={imageKey}
      answerLabels={answerLabels}
    />
  );
}

export { FactFiction };
